var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUploads2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.293 1.707a1 1 0 011.414 0l3.536 3.536a1 1 0 01-1.415 1.414L9 4.828v5.673a1 1 0 11-2 0V4.83L5.17 6.657a1 1 0 11-1.414-1.414L7.28 1.719l.012-.012z",
    fill: "#2C2D2E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 9v3a1 1 0 001 1h8a1 1 0 001-1V9h2v3a3 3 0 01-3 3H4a3 3 0 01-3-3V9h2z",
    fill: "#2C2D2E"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik03LjI5MyAxLjcwN2ExIDEgMCAwIDEgMS40MTQgMGwzLjUzNiAzLjUzNmExIDEgMCAwIDEtMS40MTUgMS40MTRMOSA0LjgyOHY1LjY3M2ExIDEgMCAxIDEtMiAwVjQuODNMNS4xNyA2LjY1N2ExIDEgMCAxIDEtMS40MTQtMS40MTRsMy41MjQtMy41MjQuMDEyLS4wMTJ6IiBmaWxsPSIjMkMyRDJFIi8+PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0zIDl2M2ExIDEgMCAwIDAgMSAxaDhhMSAxIDAgMCAwIDEtMVY5aDJ2M2EzIDMgMCAwIDEtMyAzSDRhMyAzIDAgMCAxLTMtM1Y5aDJ6IiBmaWxsPSIjMkMyRDJFIi8+PC9zdmc+";
export { SvgUploads2 as ReactComponent };